export default "__VITE_ASSET__CjgqJaS4__"